<template>
  <v-flex class="pa-3" style="background: #e5e5e5;" xs12>
    <v-simple-table style="border: 1px solid #e2e2e2" dense>
      <template v-slot:default>
        <thead>
          <tr>
            <td class="font-weight-bold">#ID</td>
            <td class="font-weight-bold">CLIENTE</td>
            <td class="font-weight-bold">STATUS</td>
            <td class="font-weight-bold">BRUTO</td>
            <td class="font-weight-bold">TAXAS</td>
            <td class="font-weight-bold">IMPOSTOS</td>
            <td class="font-weight-bold">LIQUIDO</td>
            <td class="font-weight-bold">DATA</td>
          </tr>
        </thead>
        <tbody>
          <tr
            :style="`cursor: pointer; background: ${i % 2 === 0 ? '#f2f2f2' : '#fff'}`"
            v-for="(item, i) in get_relatorios.docs"
            :key="item._id || item.id"
            @click="abre_modal_view_relatorio(item)"
          >
            <td style="width: 10px" class="font-weight-bold">
              #{{ item.id_transacao || item.id_relatorio || item._id }}
            </td>
            <td>{{ clientName(item) }}</td>
            <td>{{ item.status_do_pedido || "-" }}</td>
            <td>{{ formatMoney(financialValue(item, "gross_total")) }}</td>
            <td class="red--text font-weight-bold fonte">
              {{ formatMoney(financialValue(item, "payment_taxes_total")) }}
            </td>
            <td class="red--text font-weight-bold fonte">
              {{ formatMoney(financialValue(item, "report_taxes_total")) }}
            </td>
            <td class="green--text font-weight-bold fonte">
              {{ formatMoney(financialValue(item, "net_total")) }}
            </td>
            <td>{{ formatDate(item.created_at) }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["get_relatorios"])
  },
  methods: {
    ...mapActions(["abre_modal_view_relatorio"]),
    clientName(item) {
      return (
        item.client && item.client.nome ||
        item.compra && item.compra.cliente && item.compra.cliente.nome ||
        item.nome ||
        "-"
      );
    },
    financialValue(item, field) {
      if (item.financial_report && item.financial_report[field] !== undefined) {
        return item.financial_report[field];
      }
      return field === "gross_total" || field === "net_total"
        ? item.compra && item.compra.preco_total
        : 0;
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
    },
    formatDate(value) {
      if (!value) return "-";
      return this.$moment(value).format("DD/MM/YYYY");
    }
  }
};
</script>
